var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Cookies from "js-cookie";
import { observable, action, runInAction, computed, toJS } from "mobx";
import http, { Q } from '@http';
import { getLocationId, isIH } from "@common/utils/index";
import { EventLogReferenceType, PredefinedProcareProjectWOType, PredefinedProcareProjectWOTypeRename, PredefinedWoType, PredefinePriority, RecommendType, SpecificTime, TimeQuantum } from "@common/enums/base";
import moment from "moment";
import { cookie } from "@common/utils/storage";
import { AutoScheduleFormatResult } from "@common/viewModel";
import { isEqual, isEmpty } from "lodash-es";
import { AvailAbilityStep, AvailabilityType, CompareTime, ContactKey } from "@common/enums/availability";
var regionalScriptFilterWoTypes = [
    PredefinedWoType.Recall,
    PredefinedWoType.ResidentResponsibility
];
var AvailabilityStore = /** @class */ (function () {
    function AvailabilityStore() {
        this.clientId = Cookies.get("clientId");
        this.slaStartTime = null;
        this.slaEndTime = null;
        this.timeZone = null;
        this.formattedSLAEndTime = null;
        this.selectedAvailabilityTimes = [];
        this.reviewAvailabilityTimeList = [];
        this.priority = null;
        this.woTypeId = null;
        this.serviceParam = {};
        this.residentPreferredSchedule = {};
        this.calendarDate = null;
        this.loading = false;
        this.isRender = false;
        this.timeBlockList = [
            { id: TimeQuantum.Allday, name: SpecificTime.Allday, rank: 1 },
            { id: TimeQuantum.Morning, name: SpecificTime.Morning, rank: 2 },
            { id: TimeQuantum.Afternoon, name: SpecificTime.Afternoon, rank: 3 }
        ];
        this.regionScriptWoTypeId = null;
        this.isRecallWo = false;
        this.storePriorityIdParam = null;
        this.storeWOTypeIdParam = null;
        this.regionScriptPriority = null;
        this.isPriorityBeRegionScriptModify = false;
        this.hasRegionalScriptFutureToggle = false;
        this.isEnableResidentSchedule = false;
        this.isCAHManaged = false;
        this.autoScheduleRawData = {};
        this.trackData = [];
        this.selectedSchedule = {};
        this.isShowBundle = false;
        this.autoScheduleInfo = '';
        this.isShowAllOptions = false;
        this.scheduleTimeBlocks = {};
        this.autoScheduleModel = {};
        this.bundleWOs = [];
        this.urgentIHTNoRecommendSpecificProcess = false;
        this.availabilityStep = AvailAbilityStep.AvailabilityIndex;
        this.availabilityType = null;
        this.flexibleType = null;
        this.isSkip = false;
        this.isSwitchToLimited = false;
        this.isSwitchToFlexible = false;
        this.isStay = false;
        this.utcOffset = null;
        this.contactOriginPhone = null;
        this.contactPhone = null;
        this.contactFlagofPhonesForTextMessagingApproved = false;
        this.contactIsOriginApproved = false;
        this.isCanServiceScheduleOptimization = false;
        this.isSelectPushOutTechnician = false;
        this.recallCertifierType = null;
        this.certifiedRecallWoId = null;
        this.isRecallLessen = false;
        this.selectedAvailabilityTimes = [
            { date: null, formatDate: '', timeQuantumId: '', timeQuantumValue: '', isActive: false, availabilityTime: 'Slot', rank: null }
        ];
    }
    AvailabilityStore.prototype.setParams = function (key, value) {
        var _a;
        Object.assign(this, (_a = {}, _a[key] = value, _a));
    };
    Object.defineProperty(AvailabilityStore.prototype, "autoScheduleRecommendLength", {
        get: function () {
            var topRecommends = [];
            var recommends = [];
            if (this.autoScheduleRawData.pullInRecommend && this.autoScheduleRawData.pullInRecommend.topRecommends) {
                topRecommends = this.autoScheduleRawData.pullInRecommend.topRecommends;
            }
            if (this.autoScheduleRawData.pullInRecommend && this.autoScheduleRawData.pullInRecommend.recommends) {
                recommends = this.autoScheduleRawData.pullInRecommend.recommends;
            }
            return __spreadArrays(topRecommends, recommends).length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvailabilityStore.prototype, "isCritical", {
        get: function () {
            return this.priority === PredefinePriority.Critical;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvailabilityStore.prototype, "isExistVisit", {
        get: function () {
            var _a, _b, _c;
            if (!this.autoScheduleRawData) {
                return false;
            }
            var top3 = (_b = (_a = this.autoScheduleRawData) === null || _a === void 0 ? void 0 : _a.pullInRecommend) === null || _b === void 0 ? void 0 : _b.topRecommends;
            var hasTechnician = top3.length > 0;
            if (!hasTechnician)
                return false;
            var hasVisit = ((_c = top3[0]) === null || _c === void 0 ? void 0 : _c.visitId) > 0;
            if (!hasVisit && hasTechnician) {
                return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    AvailabilityStore.prototype.initNewAvailabilityData = function () {
        this.availabilityStep = AvailAbilityStep.AvailabilityIndex;
        this.availabilityType = null;
        this.flexibleType = null;
        this.isStay = false;
        this.contactOriginPhone = null;
        this.contactPhone = null;
        this.contactFlagofPhonesForTextMessagingApproved = false;
        this.contactIsOriginApproved = false;
    };
    AvailabilityStore.prototype.switchToLimited = function () {
        this.availabilityStep = AvailAbilityStep.LimitedTime;
        this.availabilityType = AvailabilityType.Limited;
        this.flexibleType = null;
        this.isSwitchToFlexible = false;
        this.isSwitchToLimited = false;
        this.clearAvailabilityData();
    };
    AvailabilityStore.prototype.switchToFlexible = function () {
        this.availabilityStep = AvailAbilityStep.FlexibleIndex;
        this.availabilityType = AvailabilityType.Flexible;
        this.flexibleType = null;
        this.isSwitchToFlexible = false;
        this.isSwitchToLimited = false;
        this.clearAvailabilityData();
    };
    AvailabilityStore.prototype.updateSummaryPhoneData = function (data, key) {
        if (key === ContactKey.Phone) {
            this.contactPhone = data;
            this.updateDefaultApproved();
        }
        if (key === ContactKey.FlagofPhonesForTextMessagingApproved) {
            this.contactFlagofPhonesForTextMessagingApproved = data;
        }
    };
    AvailabilityStore.prototype.updateDefaultApproved = function () {
        if (this.contactPhone === this.contactOriginPhone) {
            this.contactFlagofPhonesForTextMessagingApproved = this.contactIsOriginApproved;
        }
    };
    AvailabilityStore.prototype.checkExpirationTime = function (block) {
        if (!this.calendarDate) {
            return false;
        }
        var calendarFormatDate = moment(this.calendarDate).format('YYYY MM DD');
        var currentLocalTime = moment().utc().add(this.utcOffset, 'h').format('YYYY MM DD H:m:s');
        var compareMorningTime = moment(calendarFormatDate + " " + CompareTime.Morning).format('YYYY MM DD H:m:s');
        var compareAfternoonTime = moment(calendarFormatDate + " " + CompareTime.Afternoon).format('YYYY MM DD H:m:s');
        var isAfterMorningCompareTime = moment(currentLocalTime).isAfter(moment(compareMorningTime));
        var isAfterAfternoonCompareTime = moment(currentLocalTime).isAfter(moment(compareAfternoonTime));
        if (block.id === TimeQuantum.Morning && !!isAfterMorningCompareTime) {
            return true;
        }
        if (block.id === TimeQuantum.Afternoon && !!isAfterAfternoonCompareTime) {
            return true;
        }
        if (block.id === TimeQuantum.Allday && !!isAfterAfternoonCompareTime) {
            return true;
        }
        return false;
    };
    AvailabilityStore.prototype.getResidentInfo = function (residentId) {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getResidentInfo(residentId);
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            var allPhoneList = [];
                            if (!isEmpty(data.phoneList)) {
                                allPhoneList = allPhoneList.concat(data.phoneList);
                            }
                            if (!isEmpty(data.additionalPhoneList)) {
                                allPhoneList = allPhoneList.concat(data.additionalPhoneList);
                            }
                            var primaryPhone = allPhoneList.find(function (x) { return !!x.isPrimaryPhone; });
                            _this.contactOriginPhone = primaryPhone === null || primaryPhone === void 0 ? void 0 : primaryPhone.phoneNumber;
                            _this.contactPhone = primaryPhone === null || primaryPhone === void 0 ? void 0 : primaryPhone.phoneNumber;
                            _this.contactFlagofPhonesForTextMessagingApproved = primaryPhone === null || primaryPhone === void 0 ? void 0 : primaryPhone.isTextMessagingApproved;
                            if (!!(primaryPhone === null || primaryPhone === void 0 ? void 0 : primaryPhone.isTextMessagingApproved)) {
                                _this.contactIsOriginApproved = true;
                            }
                            else {
                                _this.contactIsOriginApproved = false;
                            }
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    Object.defineProperty(AvailabilityStore.prototype, "isNextDiabled", {
        get: function () {
            if (this.isCritical || !this.isShowAavilability) {
                return false;
            }
            switch (this.availabilityStep) {
                case AvailAbilityStep.AvailabilityIndex: {
                    return !this.availabilityType;
                }
                case AvailAbilityStep.FlexibleIndex: {
                    return !this.flexibleType;
                }
                case AvailAbilityStep.FlexibleTime: {
                    return this.selectedAvailabilityTimes.filter(function (x) { return !!x.isActive; }).length <= 0;
                }
                case AvailAbilityStep.LimitedTime: {
                    return this.selectedAvailabilityTimes.filter(function (x) { return !!x.isActive; }).length <= 0;
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvailabilityStore.prototype, "isAutoScheduleNextDisabled", {
        get: function () {
            return Object.keys(this.selectedSchedule).length === 0 &&
                Object.keys(this.autoScheduleRawData).length > 0 &&
                !(!this.isShowBundle && this.scheduleTimeBlocks.allRecommendList && this.scheduleTimeBlocks.allRecommendList.length === 0);
        },
        enumerable: false,
        configurable: true
    });
    AvailabilityStore.prototype.clearByQuestionChange = function (origin, target) {
        if (!isEqual(origin, target)) {
            this.clear();
        }
        if (isEqual(origin, target) && this.isShowAavilability) {
            this.clearAutoScheduleData();
        }
        if (isEqual(origin, target) && this.isShowAutoSchedule) {
            this.clearAvailabilityData();
        }
    };
    AvailabilityStore.prototype.clear = function () {
        this.clearAvailabilityData();
        this.clearAutoScheduleData();
    };
    AvailabilityStore.prototype.clearAvailabilityData = function () {
        this.selectedAvailabilityTimes = [
            { date: null, formatDate: '', timeQuantumId: '', timeQuantumValue: '', isActive: false, availabilityTime: 'Slot', rank: null }
        ];
        this.timeBlockList = [
            { id: TimeQuantum.Allday, name: SpecificTime.Allday, rank: 1 },
            { id: TimeQuantum.Morning, name: SpecificTime.Morning, rank: 2 },
            { id: TimeQuantum.Afternoon, name: SpecificTime.Afternoon, rank: 3 }
        ];
        this.residentPreferredSchedule = {};
        this.reviewAvailabilityTimeList = [];
    };
    AvailabilityStore.prototype.clearAutoScheduleData = function () {
        this.selectedSchedule = {};
        this.autoScheduleModel = {};
        this.isShowAllOptions = false;
    };
    AvailabilityStore.prototype.initData = function (data) {
        this.priority = data.priority;
        this.woTypeId = data.woTypeId;
        this.serviceCategoryId = data.serviceCategoryId;
        this.serviceTypeId = data.serviceTypeId;
        this.serviceCodeId = data.serviceCodeId;
        if ((data === null || data === void 0 ? void 0 : data.isRecallCheck) !== null && (data === null || data === void 0 ? void 0 : data.isRecallCheck) !== undefined) {
            this.isRecallWo = data === null || data === void 0 ? void 0 : data.isRecallCheck;
        }
    };
    AvailabilityStore.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var p1, p2, p3, p4, p5;
            var _this = this;
            return __generator(this, function (_a) {
                this.loading = true;
                p1 = this.getIsEnableResidentPreferredSchedule();
                p2 = this.getScheduleSLATime();
                p3 = this.getRegionScript();
                p4 = this.getIsEnableResidentSchedule();
                p5 = this.getIsCAHManaged();
                Promise.all([p1, p2, p3, p4, p5]).then(function () { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.canServiceScheduleOptimization()];
                            case 1:
                                _a.sent();
                                runInAction(function () {
                                    _this.loading = false;
                                    _this.isRender = true;
                                    _this.getScheduleTimeBlocks();
                                    _this.getIsRecallLessen();
                                });
                                return [2 /*return*/];
                        }
                    });
                }); });
                return [2 /*return*/];
            });
        });
    };
    AvailabilityStore.prototype.canServiceScheduleOptimization = function () {
        return __awaiter(this, void 0, void 0, function () {
            var priority, param, data_1, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        priority = this.isPriorityBeRegionScriptModify ? this.regionScriptPriority : this.priority;
                        param = {
                            serviceCodeId: this.serviceCodeId,
                            priorityId: priority,
                            locationId: getLocationId(),
                            clientId: Cookies.get("clientId"),
                            isRecall: this.isRecallWo,
                            woTypeId: this.regionScriptWoTypeId || this.woTypeId,
                            residentId: Cookies.get("residentId"),
                            recallCertifierType: this.recallCertifierType,
                            certifiedRecallWoId: this.certifiedRecallWoId
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api().canAutoSchedule(param)];
                    case 2:
                        data_1 = _a.sent();
                        runInAction(function () {
                            _this.isCanServiceScheduleOptimization = data_1 === true ? data_1 : false;
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        runInAction(function () {
                            _this.isCanServiceScheduleOptimization = false;
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AvailabilityStore.prototype.getIsRecallLessen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var priority, param, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.isRecallLessen = false;
                        priority = this.isPriorityBeRegionScriptModify ? this.regionScriptPriority : this.priority;
                        param = {
                            serviceCodeId: this.serviceCodeId,
                            priorityId: priority,
                            locationId: getLocationId(),
                            clientId: Cookies.get("clientId"),
                            recallWoId: this.certifiedRecallWoId
                        };
                        return [4 /*yield*/, this.api().getIsRecallLessen(param)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.isRecallLessen = data === true;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AvailabilityStore.prototype.handleSelectedForReviewDisplay = function () {
        var tempList = this.selectedAvailabilityTimes.concat().filter(function (x) { return x.isActive; });
        if (tempList.every(function (x) { return !x.date; })) {
            this.reviewAvailabilityTimeList = [];
            return false;
        }
        var newList = [];
        tempList.forEach(function (x) {
            var tempIndex = newList.findIndex(function (o) { return moment(o.date).format('YYYY MM DD') === moment(x.date).format('YYYY MM DD'); });
            if (tempIndex < 0) {
                var item = {
                    date: x.date,
                    formatDate: x.formatDate,
                    list: [x]
                };
                newList.push(item);
            }
            else {
                var tempItem = newList.find(function (o) { return moment(o.date).format('YYYY MM DD') === moment(x.date).format('YYYY MM DD'); });
                tempItem.list.push(x);
                var tempItemList = tempItem.list.sort(function (a, b) {
                    return a.rank < b.rank ? -1 : 1;
                });
                tempItem.list = tempItemList;
                newList.splice(tempIndex, 1, tempItem);
            }
        });
        var targetList = newList.sort(function (a, b) {
            return moment(a.date).isBefore(b.date) ? -1 : 1;
        });
        this.reviewAvailabilityTimeList = targetList;
    };
    AvailabilityStore.prototype.getAvailabilityData = function () {
        var preferredTimeCapturePostData = {};
        if (this.isShowAavilability && !this.isCritical) {
            var _a = this.selectedAvailabilityTimes[0].timeQuantumValue.split(' - '), firstStartQuantum = _a[0], firstEndQuantum = _a[1];
            var firstStart = moment(this.selectedAvailabilityTimes[0].date).format('YYYY-MM-DD') + " " + firstStartQuantum;
            var firstEnd = moment(this.selectedAvailabilityTimes[0].date).format('YYYY-MM-DD') + " " + firstEndQuantum;
            var _b = this.selectedAvailabilityTimes[1].timeQuantumValue.split(' - '), secondStartQuantum = _b[0], secondEndQuantum = _b[1];
            var secondStart = moment(this.selectedAvailabilityTimes[1].date).format('YYYY-MM-DD') + " " + secondStartQuantum;
            var secondEnd = moment(this.selectedAvailabilityTimes[1].date).format('YYYY-MM-DD') + " " + secondEndQuantum;
            var _c = this.selectedAvailabilityTimes[2].timeQuantumValue.split(' - '), thirdStartQuantum = _c[0], thirdEndQuantum = _c[1];
            var thirdStart = moment(this.selectedAvailabilityTimes[2].date).format('YYYY-MM-DD') + " " + thirdStartQuantum;
            var thirdEnd = moment(this.selectedAvailabilityTimes[2].date).format('YYYY-MM-DD') + " " + thirdEndQuantum;
            preferredTimeCapturePostData = {
                priorityId: this.priority,
                firstPreferredStartTime: firstStart,
                firstPreferredEndTime: firstEnd,
                secondPreferredStartTime: secondStart,
                secondPreferredEndTime: secondEnd,
                thirdPreferredStartTime: thirdStart,
                thirdPreferredEndTime: thirdEnd,
                isProvidePreferredScheduleTime: this.isPreferredTimeCapturePriority,
                haveResidentPreferredSchedule: this.isEnableResidentPreferredSchedule,
                isExistSLA: true,
                sLAStartTime: this.slaStartTime,
                sLAEndTime: this.slaEndTime,
            };
        }
        this.residentPreferredSchedule = preferredTimeCapturePostData;
    };
    AvailabilityStore.prototype.updateTimeBlockList = function (value) {
        var _this = this;
        var tempList = this.timeBlockList.map(function (block) {
            var item = {
                id: block.id,
                name: block.name,
                date: value,
                rank: block.rank
            };
            var sameTimeQuantum = _this.selectedAvailabilityTimes.find(function (x) { return x.timeQuantumId === block.id &&
                moment(x.date).format('YYYY MM DD') === moment(value).format('YYYY MM DD'); });
            if (sameTimeQuantum && moment(sameTimeQuantum.date).format('YYYY MM DD') === moment(value).format('YYYY MM DD')) {
                item.active = true;
            }
            else {
                item.active = false;
            }
            return item;
        });
        this.timeBlockList = tempList;
    };
    AvailabilityStore.prototype.setAvailabilityTime = function (date, type) {
        var index = this.selectedAvailabilityTimes.filter(function (x) { return x.isActive; }).length;
        var item = {
            date: date,
            formatDate: moment(date).format('MMM D'),
            timeQuantumId: type,
            timeQuantumValue: this.timeBlockList.find(function (x) { return x.id === type; }).name,
            isActive: true,
            availabilityTime: '',
            rank: this.timeBlockList.find(function (x) { return x.id === type; }).rank
        };
        this.selectedAvailabilityTimes.splice(index, 1, item);
        this.updateTimeBlockList(date);
        this.addSlot();
    };
    AvailabilityStore.prototype.sameDayCheck = function (date) {
        if (this.selectedAvailabilityTimes.length === 1) {
            return false;
        }
        var sameDayIndex = this.selectedAvailabilityTimes.findIndex(function (x) {
            var selectedDate = moment(date);
            var itemDate = moment(x.date);
            return selectedDate.isSame(itemDate, 'day');
        });
        return sameDayIndex === -1 ? false : true;
    };
    AvailabilityStore.prototype.addSlot = function () {
        var slot = {
            date: null,
            formatDate: '',
            timeQuantumId: '',
            timeQuantumValue: '',
            isActive: false,
            availabilityTime: 'Slot',
            rank: null
        };
        if (this.selectedAvailabilityTimes.length < 21) {
            this.selectedAvailabilityTimes.push(slot);
        }
    };
    AvailabilityStore.prototype.clearAvailabilityTime = function (index, date) {
        var item = {
            date: null,
            formatDate: '',
            timeQuantumId: '',
            timeQuantumValue: '',
            isActive: false,
            availabilityTime: 'Slot',
            rank: null
        };
        this.selectedAvailabilityTimes.splice(index, 1);
        if (this.selectedAvailabilityTimes.length === 0 || this.selectedAvailabilityTimes.findIndex(function (x) { return !x.date; }) === -1) {
            this.selectedAvailabilityTimes.push(item);
        }
        this.updateTimeBlockList(date);
    };
    AvailabilityStore.prototype.getIsEnableResidentPreferredSchedule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            var _this = this;
            return __generator(this, function (_a) {
                params = {
                    locationId: getLocationId()
                };
                return [2 /*return*/, this.api().getIsEnableResidentPreferredSchedule(params).then(function (rawData) {
                        if (rawData) {
                            runInAction(function () {
                                _this.isEnableResidentPreferredSchedule = rawData;
                            });
                        }
                    })];
            });
        });
    };
    AvailabilityStore.prototype.getScheduleSLATime = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, promise, rawData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = {
                            locationId: getLocationId(),
                            clientId: this.clientId,
                            priorityId: this.priority,
                        };
                        promise = this.api().getScheduleSLATime(params);
                        return [4 /*yield*/, promise];
                    case 1:
                        rawData = _a.sent();
                        runInAction(function () {
                            if (rawData) {
                                _this.slaStartTime = rawData.slaStartTime;
                                _this.slaEndTime = rawData.slaEndTime;
                                _this.formattedSLAEndTime = rawData.formattedSLAEndTime;
                                _this.timeZone = rawData.timeZone;
                                _this.utcOffset = rawData.utcOffset;
                                _this.calendarDate = moment(rawData.slaStartTime);
                                _this.updateTimeBlockList(moment(rawData.slaStartTime));
                            }
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AvailabilityStore.prototype.updateCalendarDate = function (value) {
        this.calendarDate = value;
    };
    Object.defineProperty(AvailabilityStore.prototype, "isShowAavilability", {
        get: function () {
            return this.isEnableResidentPreferredSchedule &&
                ((!this.isInHouseTechnician &&
                    this.isPreferredTimeCapturePriority &&
                    !this.isProcare &&
                    !this.isAutoSchedule) || this.urgentIHTNoRecommendSpecificProcess);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvailabilityStore.prototype, "isShowAutoSchedule", {
        get: function () {
            return this.isAutoSchedule && !this.urgentIHTNoRecommendSpecificProcess;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvailabilityStore.prototype, "isInHouseTechnician", {
        get: function () {
            return this.regionScriptWoTypeId !== null ? this.regionScriptWoTypeId === PredefinedWoType.InHouseTechnician
                : this.woTypeId === PredefinedWoType.InHouseTechnician;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvailabilityStore.prototype, "shouldRegionalScript", {
        get: function () {
            return (!this.isRecallWo && regionalScriptFilterWoTypes.indexOf(this.woTypeId) < 0);
        },
        enumerable: false,
        configurable: true
    });
    AvailabilityStore.prototype.getRegionScript = function () {
        return __awaiter(this, void 0, Promise, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.shouldRegionalScript)
                            return [2 /*return*/];
                        this.storePriorityIdParam = this.priority;
                        this.storeWOTypeIdParam = this.woTypeId && Number(this.woTypeId);
                        promise = this.api().getRegionalScript({
                            priorityId: this.priority || 0,
                            serviceCodeId: this.serviceCodeId
                        });
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            if (!!data) {
                                if ((data.woTypeId !== null) && (data.woTypeId !== _this.woTypeId)) {
                                    _this.regionScriptWoTypeId = data.woTypeId;
                                }
                                if ((data.priorityId !== null) && (data.priorityId !== _this.regionScriptPriority)) {
                                    _this.regionScriptPriority = data.priorityId;
                                    _this.isPriorityBeRegionScriptModify = true;
                                }
                                _this.hasRegionalScriptFutureToggle = true;
                            }
                            else {
                                _this.hasRegionalScriptFutureToggle = false;
                            }
                        });
                        return [2 /*return*/, promise];
                }
            });
        });
    };
    AvailabilityStore.prototype.checkIsRecallWo = function (serviceCategoryId, serviceCodeId) {
        return __awaiter(this, void 0, void 0, function () {
            var isRecallWo;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().checkIsRecallWo({
                            serviceCategoryId: serviceCategoryId,
                            woTypeId: this.woTypeId || PredefinedWoType.WorkOrder,
                            serviceCodeId: serviceCodeId
                        })];
                    case 1:
                        isRecallWo = _a.sent();
                        runInAction(function () {
                            _this.isRecallWo = isRecallWo;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AvailabilityStore.prototype, "isPreferredTimeCapturePriority", {
        get: function () {
            var showPriorityIds = [
                PredefinePriority.Critical,
                PredefinePriority.Emergency,
                PredefinePriority.RoutineStandardService,
                PredefinePriority.RoutineExpeditedService,
                PredefinePriority.NextAvailableService
            ];
            var result = showPriorityIds.indexOf(this.priority) !== -1;
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvailabilityStore.prototype, "isProcare", {
        get: function () {
            return (this.serviceCategoryId === PredefinedProcareProjectWOType.ServiceCategoryId &&
                this.serviceTypeId === PredefinedProcareProjectWOType.ServiceTypeId &&
                this.serviceCodeId === PredefinedProcareProjectWOType.ServiceCodeId) || (this.serviceCategoryId === PredefinedProcareProjectWOTypeRename.ServiceCategoryId &&
                this.serviceTypeId === PredefinedProcareProjectWOTypeRename.ServiceTypeId &&
                this.serviceCodeId === PredefinedProcareProjectWOTypeRename.ServiceCodeId);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvailabilityStore.prototype, "isAutoSchedule", {
        get: function () {
            return this.isCanServiceScheduleOptimization && this.isEnableResidentSchedule;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AvailabilityStore.prototype, "notRecall", {
        get: function () {
            var computedWoType = this.regionScriptWoTypeId !== null ? this.regionScriptWoTypeId : this.woTypeId;
            return (!this.isRecallWo && computedWoType !== PredefinedWoType.Recall);
        },
        enumerable: false,
        configurable: true
    });
    AvailabilityStore.prototype.getIsEnableResidentSchedule = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().isEnableResidentSchedule()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.isEnableResidentSchedule = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AvailabilityStore.prototype.getIsCAHManaged = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getIsCAHManaged()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.isCAHManaged = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AvailabilityStore.prototype.logRegionalScriptChange = function (woId) {
        if (!this.shouldRegionalScript)
            return;
        if (!this.hasRegionalScriptFutureToggle)
            return;
        var params = {
            woId: woId,
            sourceData: {
                PriorityId: this.storePriorityIdParam,
                WoTypeId: this.storeWOTypeIdParam,
                ClientNTE: null
            },
            EventLogReferenceType: EventLogReferenceType.ReactiveWO,
        };
        return this.api().regionalScriptLog(params);
    };
    AvailabilityStore.prototype.getScheduleTimeBlocks = function () {
        return __awaiter(this, void 0, void 0, function () {
            var clientId, locationId, priorityId, param, promise, rawData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.isAutoSchedule) {
                            return [2 /*return*/, false];
                        }
                        this.loading = true;
                        clientId = Cookies.get('clientId');
                        locationId = cookie("locationId");
                        priorityId = this.regionScriptPriority ? this.regionScriptPriority : this.priority;
                        param = {
                            serviceCodeId: this.serviceCodeId,
                            priorityId: priorityId,
                            locationId: locationId,
                            canScheduleInWeekend: false,
                            clientId: clientId,
                            woTypeId: this.regionScriptWoTypeId || this.woTypeId,
                            residentId: Cookies.get("residentId"),
                            startTime: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                            recallCertifierType: this.recallCertifierType,
                            certifiedRecallWoId: this.certifiedRecallWoId
                        };
                        promise = this.api().getScheduleTimeWindows(param);
                        return [4 /*yield*/, promise];
                    case 1:
                        rawData = _a.sent();
                        runInAction(function () {
                            _this.checkUrgentIHTNoRecommendData(rawData);
                            if (rawData) {
                                _this.autoScheduleRawData = rawData;
                                if (rawData.pullInRecommend)
                                    _this.trackData = rawData.pullInRecommend.trackData;
                                _this.checkBoundle();
                                _this.scheduleTimeBlocks = _this.computeScheduleTimeBlocks();
                            }
                            if (isEmpty(rawData) ||
                                (rawData &&
                                    isEmpty(rawData.pushOutRecommend) &&
                                    isEmpty(rawData.pullInRecommend.topRecommends) &&
                                    isEmpty(rawData.pullInRecommend.recommends))) {
                                _this.autoScheduleRawData = rawData ? {
                                    recommendAffiliateType: rawData === null || rawData === void 0 ? void 0 : rawData.recommendAffiliateType,
                                    recommendKey: rawData === null || rawData === void 0 ? void 0 : rawData.recommendKey,
                                    submissionPayload: rawData === null || rawData === void 0 ? void 0 : rawData.submissionPayload,
                                    recommendReason: rawData === null || rawData === void 0 ? void 0 : rawData.recommendReason
                                } : {};
                                _this.isShowBundle = false;
                                _this.scheduleTimeBlocks = new AutoScheduleFormatResult();
                                _this.clearAutoScheduleData();
                            }
                            if (rawData && rawData.pullInRecommend && rawData.pullInRecommend.recommends &&
                                _this.checkPullInNotTechnicianIdData(rawData.pullInRecommend.recommends)) {
                                var tempData_1 = JSON.parse(JSON.stringify(_this.selectedSchedule));
                                var item = rawData.pullInRecommend.recommends.find(function (x) {
                                    if (x.visitId === tempData_1.visitId &&
                                        x.scheduleStartTime === tempData_1.scheduleStartTime &&
                                        x.scheduleEndTime === tempData_1.scheduleEndTime &&
                                        x.technicianScores[0].technicianId === tempData_1.technicianScores[0].technicianId) {
                                        return x;
                                    }
                                });
                                if (!item) {
                                    _this.clearAutoScheduleData();
                                }
                            }
                            _this.loading = false;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AvailabilityStore.prototype.isSpecialPriority = function (priorityId) {
        return [PredefinePriority.NextAvailableService, PredefinePriority.RoutineExpeditedService, PredefinePriority.RoutineStandardService].filter(function (x) { return x === Number(priorityId); }).length;
    };
    AvailabilityStore.prototype.checkUrgentIHTNoRecommendData = function (rawData) {
        var priorityId = this.regionScriptPriority ? this.regionScriptPriority : this.priority;
        var noRecommendData = isEmpty(rawData) ||
            (rawData &&
                isEmpty(rawData.pushOutRecommend) &&
                isEmpty(rawData.pullInRecommend.topRecommends) &&
                isEmpty(rawData.pullInRecommend.recommends));
        if (isIH() && this.isInHouseTechnician && this.isSpecialPriority(priorityId) && noRecommendData) {
            this.urgentIHTNoRecommendSpecificProcess = true;
        }
        else {
            this.urgentIHTNoRecommendSpecificProcess = false;
        }
    };
    AvailabilityStore.prototype.checkPullInNotTechnicianIdData = function (list) {
        if (isEmpty(list)) {
            return false;
        }
        var tempList = [];
        list.forEach(function (x) {
            tempList = tempList.concat(x.technicianScores);
        });
        return tempList.every(function (x) { return !x.technicianId; });
    };
    AvailabilityStore.prototype.checkBoundle = function () {
        if (this.autoScheduleRawData && this.autoScheduleRawData.pushOutRecommend) {
            this.isShowBundle = true;
            this.autoScheduleRawData.pushOutRecommend && this.setSelectedSchedule(this.autoScheduleRawData.pushOutRecommend);
            this.getBundleWOs(this.autoScheduleRawData.pushOutRecommend.visitId);
        }
        else {
            this.isShowBundle = false;
        }
    };
    AvailabilityStore.prototype.setSelectedSchedule = function (schedule) {
        this.selectedSchedule = schedule;
    };
    AvailabilityStore.prototype.computeScheduleTimeBlocks = function () {
        var tempAutoScheduleData = this.autoScheduleRawData;
        var targetResult = new AutoScheduleFormatResult();
        if (tempAutoScheduleData.pushOutRecommend && Object.keys(tempAutoScheduleData.pushOutRecommend).length > 0) {
            targetResult.pushOutRecommendList = this.mapTimeBlocks([tempAutoScheduleData.pushOutRecommend]);
        }
        if (!(tempAutoScheduleData && tempAutoScheduleData.pullInRecommend)) {
            targetResult.allRecommendList = [];
            targetResult.topRecommendList = [];
            return targetResult;
        }
        tempAutoScheduleData.pullInRecommend.topRecommends.map(function (x) {
            x.isRecommend = true;
        });
        tempAutoScheduleData.pullInRecommend.recommends.map(function (x) {
            x.isRecommend = false;
        });
        if (tempAutoScheduleData.pullInRecommend.topRecommends && tempAutoScheduleData.pullInRecommend.topRecommends.length > 0) {
            targetResult.topRecommendList = this.mapTimeBlocks(tempAutoScheduleData.pullInRecommend.topRecommends);
        }
        else if (tempAutoScheduleData.pullInRecommend.recommends && tempAutoScheduleData.pullInRecommend.recommends.length > 0) {
            var tempList = tempAutoScheduleData.pullInRecommend.recommends.concat();
            var index = tempAutoScheduleData.pullInRecommend.recommends.length > 3 ? 3 : tempAutoScheduleData.pullInRecommend.recommends.length;
            targetResult.topRecommendList = this.mapTimeBlocks(tempList.splice(0, index));
        }
        var allOptions = __spreadArrays(tempAutoScheduleData.pullInRecommend.topRecommends, tempAutoScheduleData.pullInRecommend.recommends);
        if (allOptions.length > 0) {
            targetResult.allRecommendList = this.mapTimeBlocks(allOptions);
        }
        return targetResult;
    };
    AvailabilityStore.prototype.mapTimeBlocks = function (list) {
        var tempList = list.concat();
        var newList = [];
        tempList.forEach(function (x) {
            var tempIndex = newList.findIndex(function (o) { return moment(o.date).format('YYYY MM DD') === moment(x.scheduleStartTime).format('YYYY MM DD'); });
            x.timeQuantumValue = moment(x.scheduleStartTime).format('hh:mm A') + " - " + moment(x.scheduleEndTime).format('hh:mm A');
            if (tempIndex < 0) {
                var item = {
                    date: x.scheduleStartTime,
                    formatDate: "<b>" + moment(x.scheduleStartTime).format('MMMM DD') + "</b> - " + moment(x.scheduleStartTime).format('dddd'),
                    list: [x]
                };
                newList.push(item);
            }
            else {
                var tempItem = newList.find(function (o) { return moment(o.date).format('YYYY MM DD') === moment(x.scheduleStartTime).format('YYYY MM DD'); });
                tempItem.list.push(x);
                var tempItemList = tempItem.list.sort(function (a, b) {
                    return a.scheduleStartTime < b.scheduleStartTime ? -1 : 1;
                });
                tempItem.list = tempItemList;
                newList.splice(tempIndex, 1, tempItem);
            }
        });
        var targetList = newList.sort(function (a, b) {
            return moment(a.date).isBefore(b.date) ? -1 : 1;
        });
        return targetList;
    };
    AvailabilityStore.prototype.getAutoScheduleData = function () {
        var selectedSchedule = this.selectedSchedule;
        var autoScheduleRawData = this.autoScheduleRawData;
        if (Object.keys(this.selectedSchedule).length === 0) {
            this.autoScheduleModel = null;
            return false;
        }
        var tempData = {};
        tempData = {
            scheduleStartTime: selectedSchedule.scheduleStartTime,
            scheduleEndTime: selectedSchedule.scheduleEndTime,
            affiliateId: selectedSchedule.affiliateId,
            technicianScores: toJS(selectedSchedule.technicianScores),
            visitId: selectedSchedule.visitId,
            timeofSlot_Rank: moment(selectedSchedule.scheduleStartTime).format('MM/DD/YYYY hh:mm A') + " - " + moment(selectedSchedule.scheduleEndTime)
                .format('MM/DD/YYYY hh:mm A') + "  " + selectedSchedule.indexOf + " ",
            rank: selectedSchedule ? selectedSchedule.indexOf : 1,
            isExistVisit: this.isExistVisit,
            isSelectPushOutTechnician: this.isSelectPushOutTechnician,
        };
        this.autoScheduleModel = tempData;
    };
    AvailabilityStore.prototype.canSchedule = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return __awaiter(this, void 0, void 0, function () {
            var canSchedule, error_2;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!(!isIH() && ((_a = this.autoScheduleModel) === null || _a === void 0 ? void 0 : _a.rank))) return [3 /*break*/, 4];
                        _k.label = 1;
                    case 1:
                        _k.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.api().canScheduleBySO({
                                locationId: Cookies.get("locationId"),
                                clientId: Cookies.get("clientId"),
                                visitId: (_b = this.autoScheduleModel) === null || _b === void 0 ? void 0 : _b.visitId,
                                isSelectPushOutTechnician: (_c = this.autoScheduleModel) === null || _c === void 0 ? void 0 : _c.isSelectPushOutTechnician,
                                rank: (_d = this.autoScheduleModel) === null || _d === void 0 ? void 0 : _d.rank,
                                isExistVisit: (_e = this.autoScheduleModel) === null || _e === void 0 ? void 0 : _e.isExistVisit,
                                startTime: (_f = this.autoScheduleModel) === null || _f === void 0 ? void 0 : _f.scheduleStartTime,
                                endTime: (_g = this.autoScheduleModel) === null || _g === void 0 ? void 0 : _g.scheduleEndTime,
                                serviceCodeId: this.serviceCodeId,
                                priorityId: this.regionScriptPriority ? this.regionScriptPriority : this.priority,
                                technicianIds: ((_h = this.autoScheduleModel) === null || _h === void 0 ? void 0 : _h.technicianScores) && ((_j = this.autoScheduleModel.technicianScores) === null || _j === void 0 ? void 0 : _j.map(function (x) { return x.technicianId; }))
                            })];
                    case 2:
                        canSchedule = _k.sent();
                        if (canSchedule === false) {
                            return [2 /*return*/, false];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _k.sent();
                        return [2 /*return*/, true];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AvailabilityStore.prototype.getBundleWOs = function (visitId) {
        return __awaiter(this, void 0, void 0, function () {
            var promise, data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        promise = this.api().getBundleWOs(visitId);
                        return [4 /*yield*/, promise];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.bundleWOs = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AvailabilityStore.prototype.urgentScheduleRecommandTrack = function (woId, priorityId) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, pullInRecommend, _b, recommends, _c, topRecommends, type, recommendIn5Days, recommendAfter5Days, noRecommend;
            return __generator(this, function (_d) {
                if (priorityId !== PredefinePriority.NextAvailableService)
                    return [2 /*return*/];
                if (!this.isAutoSchedule)
                    return [2 /*return*/];
                _a = this.autoScheduleRawData.pullInRecommend, pullInRecommend = _a === void 0 ? {} : _a;
                _b = pullInRecommend.recommends, recommends = _b === void 0 ? [] : _b, _c = pullInRecommend.topRecommends, topRecommends = _c === void 0 ? [] : _c;
                recommendIn5Days = recommends.length > 0 || topRecommends.length > 0;
                recommendAfter5Days = !recommendIn5Days && this.trackData.length > 0;
                noRecommend = this.trackData.length <= 0;
                if (recommendIn5Days) {
                    type = RecommendType.recommendIn5Days;
                }
                else if (recommendAfter5Days) {
                    type = RecommendType.recommendAfter5Days;
                }
                else if (noRecommend) {
                    type = RecommendType.noRecommend;
                }
                this.api().urgentScheduleRecommandTrack({ woId: woId, type: type });
                return [2 /*return*/];
            });
        });
    };
    AvailabilityStore.prototype.api = function () {
        return {
            getIsEnableResidentPreferredSchedule: function (params) { return Q(http.get("RSP/ResidentPreferredSchedule/IsEnableResidentPreferredSchedule", {
                params: params
            })); },
            getScheduleSLATime: function (params) { return Q(http.get("RSP/ResidentPreferredSchedule/GetScheduleSLATime", {
                params: params
            })); },
            getRegionalScript: function (params) {
                return Q(http.get("/RegionalScript/GetRegionalScript", { params: params }));
            },
            checkIsRecallWo: function (params) {
                return Q(http.get('/PreCheck/IsRecallWo', { params: params }));
            },
            isEnableResidentSchedule: function () { return Q(http.get('/ResidentSchedule/IsEnable')); },
            getIsCAHManaged: function () { return Q(http.post(buildURL() + "/IsCAHManaged?_=" + new Date().getTime())); },
            regionalScriptLog: function (params) {
                return Q(http.post("/RegionalScript/RegionalScriptLog", params));
            },
            getBundleWOs: function (visitId) {
                return Q(http.get("/RSP/NewRequest/GetVisitWos?visitId=" + visitId));
            },
            urgentScheduleRecommandTrack: function (params) {
                return Q(http.post("/Track/new-urgent", params));
            },
            getResidentInfo: function (residentId) {
                return Q(http.get("/LocationResident/GetResidentInfo?residentId=" + residentId));
            },
            canAutoSchedule: function (params) {
                return Q(http.get("/ScheduleOptimizationV2/can-auto-schedule", { params: params }));
            },
            getIsRecallLessen: function (params) {
                return Q(http.get("/ScheduleOptimizationV2/IsRecallLessen", { params: params }));
            },
            canScheduleBySO: function (params) {
                return Q(http.post("/ScheduleOptimization/can-schedule", params));
            },
            getScheduleTimeWindows: function (params) {
                return Q(http.get("/ScheduleOptimizationV2/schedule-time-windows", { params: params }));
            },
        };
    };
    __decorate([
        observable
    ], AvailabilityStore.prototype, "clientId", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "slaStartTime", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "slaEndTime", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "timeZone", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isEnableResidentPreferredSchedule", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "formattedSLAEndTime", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "selectedAvailabilityTimes", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "reviewAvailabilityTimeList", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "priority", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "woTypeId", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "serviceParam", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "serviceCategoryId", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "serviceTypeId", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "serviceCodeId", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "residentPreferredSchedule", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "calendarDate", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "loading", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isRender", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "timeBlockList", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "regionScriptWoTypeId", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isRecallWo", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "storePriorityIdParam", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "storeWOTypeIdParam", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "regionScriptPriority", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isPriorityBeRegionScriptModify", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "hasRegionalScriptFutureToggle", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isEnableResidentSchedule", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isCAHManaged", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "autoScheduleRawData", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "trackData", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "selectedSchedule", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isShowBundle", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "autoScheduleInfo", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isShowAllOptions", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "scheduleTimeBlocks", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "autoScheduleModel", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "bundleWOs", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "urgentIHTNoRecommendSpecificProcess", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "availabilityStep", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "availabilityType", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "flexibleType", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isSkip", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isSwitchToLimited", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isSwitchToFlexible", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isStay", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "utcOffset", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "contactOriginPhone", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "contactPhone", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "contactFlagofPhonesForTextMessagingApproved", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "contactIsOriginApproved", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isCanServiceScheduleOptimization", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isSelectPushOutTechnician", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "recallCertifierType", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "certifiedRecallWoId", void 0);
    __decorate([
        observable
    ], AvailabilityStore.prototype, "isRecallLessen", void 0);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "setParams", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "autoScheduleRecommendLength", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "isCritical", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "isExistVisit", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "initNewAvailabilityData", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "switchToLimited", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "switchToFlexible", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "updateSummaryPhoneData", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "updateDefaultApproved", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "checkExpirationTime", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "getResidentInfo", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "isNextDiabled", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "isAutoScheduleNextDisabled", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "clearByQuestionChange", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "clear", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "clearAvailabilityData", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "clearAutoScheduleData", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "initData", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "init", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "canServiceScheduleOptimization", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "getIsRecallLessen", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "handleSelectedForReviewDisplay", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "getAvailabilityData", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "updateTimeBlockList", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "setAvailabilityTime", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "sameDayCheck", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "clearAvailabilityTime", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "getIsEnableResidentPreferredSchedule", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "getScheduleSLATime", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "updateCalendarDate", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "isShowAavilability", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "isShowAutoSchedule", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "isInHouseTechnician", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "shouldRegionalScript", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "getRegionScript", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "checkIsRecallWo", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "isPreferredTimeCapturePriority", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "isProcare", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "isAutoSchedule", null);
    __decorate([
        computed
    ], AvailabilityStore.prototype, "notRecall", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "getIsEnableResidentSchedule", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "getIsCAHManaged", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "logRegionalScriptChange", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "getScheduleTimeBlocks", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "checkBoundle", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "setSelectedSchedule", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "computeScheduleTimeBlocks", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "getAutoScheduleData", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "canSchedule", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "getBundleWOs", null);
    __decorate([
        action.bound
    ], AvailabilityStore.prototype, "urgentScheduleRecommandTrack", null);
    return AvailabilityStore;
}());
export default AvailabilityStore;
export var buildURL = function (serviceParam) {
    return serviceParam
        ? "RSP/NewRequest/" + serviceParam.serviceCategoryId + "/" + serviceParam.serviceTypeId + "/" + serviceParam.serviceCodeId
        : "RSP/NewRequest";
};
